import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-question",
  "use": "icon-question-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-question\"><path d=\"M7 0a7 7 0 1 0 .001 14.001A7 7 0 0 0 7 0ZM3.92 5.238s-.229-3.125 3.066-3.125 3.095 3.095 3.095 3.095.027.975-1.089 1.834c-1.117.86-1.347.801-1.347 2.092H6.126s-.47-1.886 1.718-2.979c.46-.23.633-.488.633-1.347s-.546-1.377-1.348-1.377-1.633.144-1.633 1.777l-1.576.03Zm2.178 5.1h1.547v1.548H6.098v-1.548Z\" fill=\"#D1D1D1\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol